import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, Output, forwardRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SimpleFieldConfig } from '../simple-field.interface';
import { Subject } from 'rxjs';

@Component({
  exportAs: "simpledynamicForm",
  selector: 'simple-dynamic-form',
  templateUrl: './simple-dynamic-form.component.html',
  styleUrls: ['./simple-dynamic-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SimpleDynamicFormComponent),
      multi: true
    }
  ]
})
export class SimpleDynamicFormComponent implements OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  @Input() fields: SimpleFieldConfig[] = [];

  @Input() patchValueList: any[] = [];

  @Input() layout: any = 2;
  @Input() leadStyle = 1;

  @Input() type: any = 1;

  @Input() gapBetweenImage: any = '5px';

  @Input() displayMobileImage: any = 2;

  @Input() mobileGapBetweenImage: any = 2;

  @Input() formValue: any;

  @Input() status: any;

  minusValue: any = '2px';
  @Input() formType: any = 'outline';

  @Output() submit: EventEmitter<any> = new EventEmitter<any>();

  @Output() submitLeadDetail: EventEmitter<any> = new EventEmitter<any>();

  form: UntypedFormGroup;
  formInit: boolean = false;

  get value() {
    return this.form.value;
  }
  constructor(private fb: UntypedFormBuilder, private router: Router) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {
    // console.log("sas",this.fields);

    this.form = this.createControl();
    if (this.type == 2) {
      for (const key in this.formValue) {
        if (this.formValue.hasOwnProperty(key) && this.form.get(key)) {
          if (this.formValue[key] != null) {
            this.form.get(key)?.setValue(this.formValue[key]);
          }
        }
      }
      this.updateConditionalFieldsVisibility();
    }
    this.subscribeToFormChanges();

    this.formInit = true;


    // this.patchFormValues();

  }


  patchFormValues(): void {

    if (this.patchValueList.length > 0) {
      this.patchValueList.forEach(patchValue => {

        let index = this.fields.findIndex(item => item.fieldId === patchValue.fieldId);

        if (index >= 0) {

          this.form.get(this.fields[index].name).patchValue(patchValue.fieldValue);
        }
      });
    }


  }

  onSubmit() {

    if (this.form.valid) {
      this.submit.emit(this.form.value);
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  onSubmitNew() {

    if (this.form.valid) {
      this.submitLeadDetail.emit(this.form.value);
    } else {
      this.validateAllFormFields(this.form);
    }
  }


  createControl() {
    const group = this.fb.group({});
    this.fields.forEach(field => {
      if (field.type === "button") return;
      const control = this.fb.control(
        field.value,
        this.bindValidations(field['dynamicFormLabelValidator'] || [], field)
      );
      group.addControl(field.name, control);
    });
    return group;
  }

  bindValidations(validations: any, field?: SimpleFieldConfig) {
    if (validations && validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        if (!valid) return;
        const name = (valid.name || '').toLowerCase().trim();

        if (name === 'required') {
          if (field && (field.inputType === 'checkbox' || field.type === 'checkbox')) {
            // validator = Validators.requiredTrue;
            // validator.validator = Validators.requiredTrue;
            validList.push(Validators.requiredTrue);
          } else {
            //     validator = Validators.required;
            //     validator.validator = Validators.required;
            //   }
            //   validList.push(validator);
            // }else if(valid.name=='requiredTrue'){
            //   validator = Validators.requiredTrue;
            //   validator.validator = Validators.requiredTrue;
            //   validList.push(validator);
            // }else if(valid.name=='pattern'){
            //   validator=Validators.pattern(valid.validator);
            //   validList.push(validator);
            validList.push(Validators.required);
          }
        } else if (name === 'requiredtrue') {
          validList.push(Validators.requiredTrue);
        } else if (name === 'pattern') {
          if (valid.validator) {
            validList.push(Validators.pattern(valid.validator));
          }
        } else if (name === 'minlength') {
          const minVal = valid.minLength ?? valid.min_length ?? valid.validator;
          const min = Number(minVal);
          if (!isNaN(min) && min > 0) {
            validList.push(Validators.minLength(min));
          }
        } else if (name === 'maxlength') {
          const maxVal = valid.maxLength ?? valid.max_length ?? valid.validator;
          const max = Number(maxVal);
          if (!isNaN(max) && max > 0) {
            validList.push(Validators.maxLength(max));
          }
        } else {
          if (valid.minLength != null && valid.minLength !== '' && !isNaN(Number(valid.minLength))) {
            validList.push(Validators.minLength(Number(valid.minLength)));
          }
          if (valid.maxLength != null && valid.maxLength !== '' && !isNaN(Number(valid.maxLength))) {
            validList.push(Validators.maxLength(Number(valid.maxLength)));
          }
          if (valid.validator === 'Validators.required') {
            validList.push(Validators.required);
          }
        }
      });
      return validList.length > 0 ? Validators.compose(validList) : null;
    }
    return null;
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  calculateFlexValue(layout: number, gapBetweenImage: boolean): string {
    const baseFlex = layout === 2 ? '50%' :
      layout === 3 ? '33.33%' :
        layout === 4 ? '25%' : '100%';



    return gapBetweenImage ? `calc(${baseFlex} - ${gapBetweenImage})` : baseFlex;
  }

  evaluateCondition(conditionText: string, formValues: any): boolean {
    if (!conditionText) return true; // If no condition specified, return true

    // Use the custom evaluateExpression method to evaluate the condition
    return this.evaluateExpression(conditionText, formValues);
  }

  subscribeToFormChanges() {
    this.form.valueChanges.subscribe(() => {
      this.updateConditionalFieldsVisibility();
    });
  }

  updateConditionalFieldsVisibility() {
    this.fields.forEach(field => {
      if (field.enableConditionalField == 1) {
        const conditionResult = this.evaluateCondition(field.conditionText, this.form.value);
        field.visible = conditionResult;
      }
    });
  }


  evaluateExpression(expression: string, formValues: any): boolean {
    if (!expression) return true;

    expression = expression.replace(/\s+or\s+/g, ' || ');


    const blocks = expression.split(/\s*\|\|\s*/);

    for (const block of blocks) {
      // Split block by AND (&&) operator
      const conditions = block.split(/\s*&&\s*/);
      let allConditionsTrue = true;

      for (const condition of conditions) {
        const conditionResult = this.evaluateSingleCondition(condition.trim(), formValues);
        if (!conditionResult) {
          allConditionsTrue = false;
          break;
        }
      }

      if (allConditionsTrue) {
        return true; // If all conditions in a block are true, the OR block is true
      }
    }

    return false; // If none of the OR blocks are true
  }

  evaluateSingleCondition(condition: string, formValues: any): boolean {
    const [variable, operator, value] = condition.split(/\s*(===|!==|==|!=|<|>|<=|>=)\s*/);
    const variableValue = formValues[variable];
    const cleanValue = value.replace(/'/g, '');
    const variableValueNumber = parseFloat(variableValue);

    switch (operator) {
      case '===':
        return variableValue === cleanValue;
      case '!==':
        return variableValue !== cleanValue;
      case '==':
        return variableValue == cleanValue || variableValueNumber == parseFloat(cleanValue);
      case '!=':
        return variableValue != cleanValue && variableValueNumber != parseFloat(cleanValue);
      case '<':
        return variableValueNumber < parseFloat(cleanValue);
      case '>':
        return variableValueNumber > parseFloat(cleanValue);
      case '<=':
        return variableValueNumber <= parseFloat(cleanValue);
      case '>=':
        return variableValueNumber >= parseFloat(cleanValue);
      default:
        return false;
    }
  }


  splitConditions(expression: string): string[] {
    const conditions: string[] = [];
    let currentCondition = '';
    let bracketCount = 0;

    for (let i = 0; i < expression.length; i++) {
      const char = expression[i];

      if (char === '(') {
        bracketCount++;
      } else if (char === ')') {
        bracketCount--;
      }

      if (bracketCount === 0 && (char === '&&' || char === '||')) {
        conditions.push(currentCondition.trim());
        currentCondition = '';
      } else {
        currentCondition += char;
      }
    }

    if (currentCondition.trim() !== '') {
      conditions.push(currentCondition.trim());
    }

    return conditions;
  }


  cleanValue(value: string): any {
    // Check if value is null or undefined
    if (value == null) {
      return value;
    }

    // Remove single quotes from the value and convert to number if possible
    const cleanedValue = value.replace(/'/g, '');
    return !isNaN(cleanedValue as any) ? Number(cleanedValue) : cleanedValue;
  }

  onFieldValueChange(value: any) {


    this.submit.emit(this.form.value);


  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
